import { getUserIdFromJid } from '@/shared/utils';
import { useSelector } from 'react-redux';
import { useDraft } from '../model/draft/hooks';
import { useRepliedMessageById } from '../model/repliedMessages/selectors';

/**
 * Hook for managing the "Edit Message" state.
 * Reuses the same pattern as useReplyMessage.
 */
export const useEditMessage = (options = {}) => {
   const { activeChatJid = '' } = options;
   const activeChatId = getUserIdFromJid(activeChatJid);

   const editMessageId = useSelector(state => state.draftData?.drafts?.[activeChatId]?.editMessageId);
   const editMessage = useRepliedMessageById(editMessageId);

   const { clearEditMessage } = useDraft({ activeChatId });

   return {
      editMessageId,
      editMessage,
      clearEditMessage,
   };
};
